import styled from 'styled-components'
import { SkeletonLine } from 'components/Skeleton'
import { SeverityExplainer } from './Explainers'
import { SEVERITY_ORDER, severityMeta } from './remedialMeta'
import { BORDER, INK, MUTED } from './ui'

const SeverityBreakdown = ({ counts, ready, failed = false, onOpenView }) => {
  const total = SEVERITY_ORDER.reduce((sum, level) => sum + (counts[level] || 0), 0)
  return (
    <Panel aria-labelledby='remedial-severity-title'>
      <Head>
        <Title id='remedial-severity-title'>Open remedials by severity</Title>
        <SeverityExplainer />
      </Head>
      <Lead>Each level is counted on its own. Choose a level to see those remedials.</Lead>
      {SEVERITY_ORDER.map(level => {
        const meta = severityMeta(level)
        const value = counts[level] || 0
        const share = ready && total ? Math.round((value / total) * 100) : 0
        return (
          <Level
            key={level}
            type='button'
            onClick={() => onOpenView({ view: 'all_open', severity: [level] })}
            aria-label={ready ? `${meta.label}: ${value} open. Show them` : failed ? `${meta.label}: not loaded. Show them` : `${meta.label}: loading`}
          >
            <LevelTop>
              <Pill style={{ color: meta.color, background: meta.bg }}>{meta.label}</Pill>
              {ready ? <LevelCount>{value}</LevelCount> : failed ? <LevelCount aria-hidden='true'>?</LevelCount> : <SkeletonLine $w='28px' $h={16} />}
            </LevelTop>
            <Track aria-hidden='true'>
              <Fill style={{ width: `${share}%`, background: meta.color }} />
            </Track>
          </Level>
        )
      })}
    </Panel>
  )
}

export default SeverityBreakdown

const Panel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 12px;
`

const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Title = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: ${INK};
`

const Lead = styled.p`
  margin: 0 0 4px;
  font-size: 15px;
  color: ${MUTED};
`

const Level = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 52px;
  padding: 8px;
  border: none;
  border-radius: 8px;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
  &:hover { background: #fafafa; }
  &:focus-visible { outline: 2px solid ${INK}; outline-offset: 2px; }
`

const LevelTop = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Pill = styled.span`
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
`

const LevelCount = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ${INK};
`

const Track = styled.span`
  display: block;
  height: 8px;
  border-radius: 4px;
  background: #f4f4f5;
  overflow: hidden;
`

const Fill = styled.span`
  display: block;
  height: 100%;
  border-radius: 4px;
`
